/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* global window */
import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { get, set, map, orderBy, unionBy } from 'lodash';
import { withTranslate } from 'react-redux-multilingual';
import { requestMarketNews as RequestMarketNews, requestNewsLink, requestNewsArticle } from 'Actions/NewsActions';
import * as inputHelper from 'Utils/apiInputHelper';
import Loader from 'components/Loader/Loader';
import './NewsHeadlineList.scss';

const mapStateToProps = state => ({
	newsData: state.newsData.newsData,
	fetchingNewsData: state.newsData.fetchingNewsData
});

const mapDispatchToProps = dispatch => ({
	requestMarketNews: (QBID, APIInputs, onSuccess) => dispatch(RequestMarketNews(QBID, APIInputs, onSuccess)),
	getNewsLink: (newsId, articleId, onSuccess) => dispatch(requestNewsLink(newsId, articleId, onSuccess)),
	getNewsArticle: (result, onSuccess) => dispatch(requestNewsArticle(result, onSuccess))
});

const { format } = window || {};

class NewsHeadlineList extends React.Component {
	QBID = 176;

	newsProviders = {
		// US news
		US: [
			inputHelper.argument(
				'NewsType',
				[inputHelper.condition(
					inputHelper.operator.EQUALTO,
					['USMarketNews']
				)]
			),
			// US news
			inputHelper.argument(
				'CIBCProvider',
				[inputHelper.condition(
					inputHelper.operator.EQUALTO,
					['BusinessWire', 'PRNewswire', 'Reuters']
				)]
			)],
		// CA news
		CA: [
			inputHelper.argument(
				'NewsType',
				[inputHelper.condition(
					inputHelper.operator.EQUALTO,
					['CAMarketNews']
				)]
			),
			// CA news
			inputHelper.argument(
				'CanadianOnly',
				[inputHelper.condition(
					inputHelper.operator.EQUALTO,
					['True']
				)]
			)
		]
	}

	constructor(props) {
		super(props);

		this.state = {
			currentPage: props.currentPage || 0,
			newsItemsPerPage: props.newsItemsPerPage || 4,
			caNewsData: null,
			usNewsData: null
		};

		this.getNews = this.getNews.bind(this);
		this.openNewsModal = this.openNewsModal.bind(this);
		this.generateNewsItemElement = this.generateNewsItemElement.bind(this);
	}

	componentDidMount() {
		const { getNewsLink, getNewsArticle } = this.props;

		this.getNews(this.QBID, 'US', result => {
			this.setState({ usNewsData: result });
		});

		 this.getNews(this.QBID, 'CA', result => {
			this.setState({ caNewsData: result });
		 });

		set(window, 'mdPageActions.getArticle', articleId => {
			return new Promise(resolve => {
				getNewsLink(this.QBID, articleId, result => {
					getNewsArticle(result, articleContent => {
						resolve(articleContent);
					});
				});
			});
		});
	}

	getNews(QBID, country, onSuccess) {
		const { requestMarketNews } = this.props;
		const {
			currentPage,
			newsItemsPerPage
		} = this.state;

		const daysBack = 7;

		const dateLocal = format.moment().startOf('day');
		// convert local dateTime to UTC, set to beginning of day, return as ISO string
		const dateMax = format.moment(dateLocal).tz('America/New_York').hour(0).add(1, 'days');
		const dateMaxStr = dateMax.toISOString();
		const dateMinStr = dateMax.subtract(daysBack, 'days').toISOString();

		const APIInputs = inputHelper.getDefaultInputs;
		APIInputs.argsOperator = 'AND';
		APIInputs.sortArguments = [{ direction: 'desc', field: 'DocumentDate' }];
		APIInputs.limit = newsItemsPerPage;
		APIInputs.offset = currentPage * newsItemsPerPage;
		APIInputs.arguments = [
			inputHelper.argument(
				'DocumentDate',
				[
					inputHelper.condition(inputHelper.operator.GREATERTHANEQUALTO, [dateMinStr]),
					inputHelper.condition(inputHelper.operator.LESSTHANEQUALTO, [dateMaxStr])
				]
			)
		];

		APIInputs.arguments = APIInputs.arguments.concat(this.newsProviders[country]);

		requestMarketNews(QBID, JSON.stringify(APIInputs), onSuccess);
	}

	openNewsModal = (articleId, articleIndex, uniqueNewsItems) => {
		const { getNewsLink, getNewsArticle } = this.props;
		getNewsLink(this.QBID, articleId, result => {
			getNewsArticle(result, articleContent => {
				const callCibcModal = get(window, 'mdPageActions.openNewsModal', () => console.error('openNewsModal doesn\'t exist'));
				const newsItemsArray = map(uniqueNewsItems, article => article.articleId);
				callCibcModal(articleContent, newsItemsArray, articleIndex);
			});
		});
	}

	generateNewsItemElement = (sortedUnionNewsData, index) => {
		const { translate } = this.props;
		return get(sortedUnionNewsData, index) && (
			<Col xs className="headlines-column col-xxs">
				<h4 className="news-headline font-weight-bold truncate" title={format.string(sortedUnionNewsData[index].Headline)}>
					{format.string(sortedUnionNewsData[index].Headline)}
				</h4>
				<p className="news-item-info">
					{sortedUnionNewsData[index].Source}
					{' | '}
					{format.monthDayYear(sortedUnionNewsData[index].DocumentDate)}
				</p>
				<button
					type="button"
					className="news-item-readmore"
					onClick={() => {
						this.openNewsModal(sortedUnionNewsData[index].articleId, index, sortedUnionNewsData.slice(0, 4));
					}}
					data-docId={sortedUnionNewsData[index].articleId}>
					<span aria-hidden>{translate('readArticle')}</span>
					<span className="sr-only">{translate('readArticleSr', { headline: sortedUnionNewsData[index].Headline })}</span>
				</button>
			</Col>
		);
	}

	render() {
		const { fetchingNewsData } = this.props;
		const { usNewsData, caNewsData } = this.state;

		const unionNewsData = unionBy(get(usNewsData, 'data.items'), get(caNewsData, 'data.items'), newsItem => newsItem.Headline);
		const sortedUnionNewsData = orderBy(unionNewsData, ['DocumentDate'], ['desc']);

		return (
			<div className="market-overview-list-wrapper">
				{
					<>
						{fetchingNewsData ? <Loader /> : null}
						<Row noGutters className="news-headlines-list-row" style={{ marginTop: 0 }}>
							{[
								this.generateNewsItemElement(sortedUnionNewsData, 0),
								<Col key="sep1" xs="auto pipeline d-none d-xxs-block" aria-hidden="true" />,
								this.generateNewsItemElement(sortedUnionNewsData, 1)
							]}
						</Row>
						<Row noGutters className="news-headlines-list-row no-margin-bottom">
							{[
								this.generateNewsItemElement(sortedUnionNewsData, 2),
								<Col key="sep2" xs="auto pipeline d-none d-xxs-block" aria-hidden="true" />,
								this.generateNewsItemElement(sortedUnionNewsData, 3)
							]}
						</Row>
					</>
				}
			</div>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(NewsHeadlineList));
